(function() {
  'use strict';

  function initKeychainStation() {
    // 1. Gallery thumbnail switching
    const galleries = document.querySelectorAll('[data-ks-gallery]');
    galleries.forEach(function(gallery) {
      gallery.addEventListener('click', function(e) {
        const btn = e.target.closest('button');
        if (!btn) return;

        const buttons = gallery.querySelectorAll('button');
        buttons.forEach(function(b) {
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });

        const section = gallery.closest('section') || gallery.closest('div') || document;
        const mainSlot = section.querySelector('[data-ks-main-image]') || document.querySelector('[data-ks-main-image]');

        if (mainSlot && btn.dataset.cap !== undefined) {
          mainSlot.innerHTML = btn.dataset.cap;
        }
      });
    });

    // Helper to format currency and prevent double dollar signs ($)
    function ensureCurrency(val) {
      if (val === undefined || val === null) return '';
      const str = String(val).trim();
      if (!str) return '';
      return str.startsWith('$') ? str : '$' + str;
    }

    // 2. Variant/quantity switching
    const variantSelects = document.querySelectorAll('[data-ks-variant-select]');
    variantSelects.forEach(function(select) {
      function updateVariantDetails() {
        const selectedOption = select.selectedOptions ? select.selectedOptions[0] : select.options[select.selectedIndex];
        if (!selectedOption) return;

        const dataset = selectedOption.dataset || {};
        const priceVal = dataset.price || selectedOption.getAttribute('data-price') || dataset.ksPrice || selectedOption.getAttribute('data-ks-price') || '';
        const wasVal = dataset.was || selectedOption.getAttribute('data-was') || dataset.ksWas || selectedOption.getAttribute('data-ks-was') || '';
        const saveVal = dataset.save || selectedOption.getAttribute('data-save') || dataset.ksSave || selectedOption.getAttribute('data-ks-save') || '';
        const qtyVal = dataset.qty || selectedOption.getAttribute('data-qty') || dataset.ksQty || selectedOption.getAttribute('data-ks-qty') || '';

        const formattedPrice = ensureCurrency(priceVal);
        const formattedWas = ensureCurrency(wasVal);
        const formattedSave = ensureCurrency(saveVal);

        // Update price display
        document.querySelectorAll('[data-ks-price]').forEach(function(el) {
          el.textContent = formattedPrice;
        });

        // Update compare-at price
        document.querySelectorAll('[data-ks-was]').forEach(function(el) {
          el.textContent = formattedWas;
        });

        // Update savings badge
        document.querySelectorAll('[data-ks-save]').forEach(function(el) {
          el.textContent = formattedSave ? 'You save ' + formattedSave : '';
        });

        // Update unit quantity
        document.querySelectorAll('[data-ks-unit-qty]').forEach(function(el) {
          el.textContent = qtyVal;
        });

        // Update CTA button text with configurable prefix
        document.querySelectorAll('[data-ks-cta]').forEach(function(el) {
          let prefix = el.dataset.prefix || el.getAttribute('data-prefix') || el.getAttribute('data-cta-prefix');
          if (!prefix) {
            const text = el.textContent.trim();
            if (text.includes('—')) {
              prefix = text.split('—')[0].trim() + ' — ';
            } else if (text.includes('$')) {
              prefix = text.split('$')[0].trim() + ' ';
            } else {
              prefix = 'Add Keychain Station To My Booth — ';
            }
            el.dataset.prefix = prefix;
          }
          el.textContent = prefix + formattedPrice;
        });

        // Update sticky bar subtitle
        document.querySelectorAll('[data-ks-sticky-sub]').forEach(function(el) {
          el.textContent = formattedPrice + ' · counter + ' + qtyVal + ' keychains';
        });

        // Update final CTA price line
        document.querySelectorAll('[data-ks-final-price]').forEach(function(el) {
          el.textContent = formattedPrice + ' today · ships in 3–5 business days · Event-Ready Guarantee';
        });
      }

      select.addEventListener('change', updateVariantDetails);
      updateVariantDetails();
    });

    // 3. Sticky cart bar
    const stickyBars = document.querySelectorAll('[data-ks-sticky]');
    if (stickyBars.length > 0) {
      const handleScroll = function() {
        const isPastThreshold = (window.scrollY || window.pageYOffset || 0) > 700;
        stickyBars.forEach(function(sticky) {
          sticky.classList.toggle('on', isPastThreshold);
        });
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKeychainStation);
  } else {
    initKeychainStation();
  }
})();
